import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AvatarModule } from 'ngx-avatars';

import { PipesModule } from './pipes/pipes.module';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';
import { SpinnerModule } from '../_metronic/shared/spinner/spinner.module';
import { BlockuiModule } from '../_metronic/shared/blockui/blockui/blockui.module';
import { VideoConferenceDialogComponent } from './components/video-conference-dialog/video-conference-dialog.component';
import { ButtonComponent } from './components/button/button.component';
import { BottomDrawerComponent } from './components/bottom-drawer/bottom-drawer.component';
import { MessageInputComponent } from './components/message-input/message-input.component';
import { InputComponent } from './components/input/input.component';
import { AutosizeModule } from 'ngx-autosize';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutWrapperComponent } from './components/layout-wrapper/layout-wrapper.component';
import { TabPanelComponent } from './components/tab-panel/tab-panel.component';
import { ViewPostReplyComponent } from './components/view-post-reply/view-post-reply.component';
import { RouterModule } from '@angular/router';
import { ChatDividerComponent } from './components/chat-divider/chat-divider.component';
import { SelectComponent } from './components/select/select.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { ButtonTabsComponent } from './components/button-tabs/button-tabs.component';
import { ModalWindowComponent } from './components/modal-window/modal-window.component';
import { ModalWrapperComponent } from './components/modal-window/modal-wrapper/modal-wrapper.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { AdaptiveModalComponent } from './components/adaptive-modal/adaptive-modal.component';
import { LikesPanelComponent } from './components/likes-and-comments-panel/likes-panel.component';
import { PopupMenuComponent } from './components/popup-menu/popup-menu.component';
import { SharpenContentComponent } from './components/sharpen/sharpen-content/sharpen-content.component';
import { SharpenEditDialogComponent } from './components/sharpen/sharpen-edit-dialog/sharpen-edit-dialog.component';
import { DropDownPanelComponent } from './components/drop-down-panel/drop-down-panel.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharpenPreviewCardComponent } from './components/sharpen/sharpen-preview-card/sharpen-preview-card.component';
import { IonicModule } from '@ionic/angular';
import { AdaptiveContextMenuComponent } from './components/adaptive-context-menu/adaptive-context-menu.component';
import { ReportContentModalComponent } from './components/report-content-modal/report-content-modal.component';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';
import { ReportSendNotifyComponent } from './components/report-content-modal/report-send-notify/report-send-notify.component';
import { DeleteConfirmationModalComponent } from './components/delete-confirmation-modal/delete-confirmation-modal.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    SpinnerModule,
    AvatarModule,
    AutosizeModule,
    BlockuiModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatExpansionModule,
    InfiniteScrollModule,
    IonicModule,
  ],
  declarations: [
    UserAvatarComponent,
    VideoConferenceDialogComponent,
    ButtonComponent,
    BottomDrawerComponent,
    MessageInputComponent,
    InputComponent,
    LayoutWrapperComponent,
    TabPanelComponent,
    ViewPostReplyComponent,
    ChatDividerComponent,
    SelectComponent,
    CheckboxComponent,
    RadioButtonComponent,
    ButtonTabsComponent,
    ModalWindowComponent,
    ModalWrapperComponent,
    AdaptiveModalComponent,
    AdaptiveContextMenuComponent,
    LikesPanelComponent,
    PopupMenuComponent,
    SharpenContentComponent,
    SharpenEditDialogComponent,
    DropDownPanelComponent,
    SharpenPreviewCardComponent,
    ReportContentModalComponent,
    ReportSendNotifyComponent,
    DeleteConfirmationModalComponent,
  ],
  exports: [
    PipesModule,
    UserAvatarComponent,
    SpinnerModule,
    AvatarModule,
    VideoConferenceDialogComponent,
    ButtonComponent,
    BottomDrawerComponent,
    MessageInputComponent,
    InputComponent,
    LayoutWrapperComponent,
    TabPanelComponent,
    ViewPostReplyComponent,
    ChatDividerComponent,
    SelectComponent,
    CheckboxComponent,
    RadioButtonComponent,
    ButtonTabsComponent,
    ModalWindowComponent,
    AdaptiveModalComponent,
    AdaptiveContextMenuComponent,
    LikesPanelComponent,
    PopupMenuComponent,
    SharpenContentComponent,
    SharpenEditDialogComponent,
    DropDownPanelComponent,
    SharpenPreviewCardComponent,
    ReportContentModalComponent,
    DeleteConfirmationModalComponent,
  ],
})
export class SharedModule {
}
